<template>
  <span
     class="utm-circle-tag mini"
    :class="{
      'utm-tag-red-bg': color === '#ed5656' || color === '#ED5656',
      'utm-tag-yellow-bg': color === '#f99c80' || color === '#F99C80',
      'utm-tag-purple-bg': color === '#a2a6ec' || color === '#A2A6EC',
      'utm-tag-pink-bg': color === '#d5a2c0' || color === '#D5A2C0',
      'utm-tag-blue-bg': color === '#a5c9ff' || color === '#A5C9FF',
    }"
  >
    <template v-if="!ellipsis">{{ name }}</template>
    <!-- 超出省略显示 -->
    <template v-else>
      <!-- 限定最大字符长度 -->
      <el-tooltip
        v-if="ellipsisMaxCharLength && name && name.length > ellipsisMaxCharLength"
        :content="name"
        popper-class="utm-el-tooltip"
      >
        <div class="utm-ellipsis-txt">
          {{ name.slice(0, ellipsisMaxCharLength) }}...
        </div>
        <template #content>
          <div>{{ name }}</div>
        </template>
      </el-tooltip>

      <utm-ellipsis v-else :content="name" :transfer="transfer"></utm-ellipsis>
    </template>
  </span>
</template>

<script>
export default {
  name: "tag",
  props: {
    color: {
      type: String,
      default: "#ed5656",
    },
    name: {
      type: String,
      default: "",
    },
    transfer: {
      type: Boolean,
      default: true,
    },
    ellipsis: {
      type: Boolean,
      default: false,
    },
    // 限定最大字符长度, 不限制时需设置为0，默认12
    ellipsisMaxCharLength: {
      type: Number,
      default: 12, // #37886 【Incident - My Incident - My Alarm】Tag信息展示不全
    },
  },
  data() {
    return {};
  },
};
</script>

<style>
.el-tooltip__popper[x-placement^=bottom] .popper__arrow{
  border-bottom-color: rgba(70, 76, 91, .9) !important;
}
.el-tooltip__popper[x-placement^=bottom] .popper__arrow:after {
  border-bottom-color: rgba(70, 76, 91, .9) !important;
}
/* 自定义el-tooltip 样式 */
.utm-el-tooltip {
  z-index: 9999 !important;
  background: rgba(70, 76, 91, .9) !important;
  font-size: 14px !important;
  color: #FFF !important;
}
</style>



// WEBPACK FOOTER //
// src/admin/components/commonComponents/tag.vue